import React from "react";
import "./GlobalLoader.css";

const GlobalLoader = ({ show = false }) => {
  if (!show) {
    return null;
  }

  return (
    <div className="global-loader-backdrop">
      <div className="global-loader-circle" />
    </div>
  );
};

export default GlobalLoader;

